<template>
  <div id="app">
    <!-- Transition 
    <transition
      name="fade"
      mode="out-in"
    >
    -->
     <router-view/>
    <!-- Transition </transition> -->
  </div>
</template>

<script>
export default {
  name: 'App', 
}
</script>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
  }
  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
  
</style>



// WEBPACK FOOTER //
// src/App.vue